<template>
	<div>
		<div style="text-align: center;"><button @click='print'>打印</button></div>
		<div ref="print" @click="print" style="width: 50rem;;">
			<div style="text-align: center;font-size: 1rem;color: #000;">QMIS Securities Limited</div>  
			<div style="text-align: right;">客戶戶口: 1000005 由日期：31 May21 交易所：HKEX</div>
			<div class='morediv'>
				<div v-for='(item,ind) in metdata' 
				:style='{textAlign:item.align!==""?item.align:"center", width:item.width}' >{{item.name}}
				</div>
			</div>
		
			<!-- <span class='no-want-print'>不需要打印的内容</span> -->
		</div>
		
	</div>
</template>

<script>
	export default{
		data() {
			return {
				metdata:[{
					name:'訂單號碼',
					cdland:'',
					align:'',
					width:'5rem',
				},{
					name:'買/沽',
					align:'',
					width:'3rem',
				},
				{
					name:'商品',
					align:'',
					width:'5rem',
				},{
					name:'價格',
					align:'',
					width:'5rem',
				},{
					name:'數量',
					align:'',
					width:'5rem',
				},{
					name:'已成交數量',
					align:'',
					width:'5rem',
				},{
					name:'狀態',
					align:'',
					width:'5rem',
				},{
					name:'輸入時間',
					align:'',
					width:'5rem',
				},{
					name:'輸入用戶',
					align:'',
					width:'5rem',
				},{
					name:'備註',
					align:'',
					width:'5rem',
				}]
			}
		},
		mounted() {
			console.log(this.metdata)
		},
		methods:{
			print(){
				this.$print(this.$refs.print, { 'no-print': '.no-want-print' })
			}
		}
	}
</script>

<style lang="scss">
	.morediv{
		border-bottom: 1px solid #000000;
		div{
			display: inline-block;
			color: #000;
		}
	}
</style>
